<script lang="ts" setup>
import constants from '~/constants'
import helpers from '~/helpers'
import { useCartStore } from '~/store/cart'

const cartStore = useCartStore()

const shippingData = computed(() => cartStore.shippingData)
</script>

<template>
  <BlockWithBorder v-if="shippingData">
    <div class="h4">
      Выбранный пункт выдачи заказов Boxberry
    </div>

    <table>
      <tbody>
        <tr v-if="shippingData.name">
          <th class="w-px whitespace-nowrap">
            Город
          </th>
          <td>{{ shippingData.name }}</td>
        </tr>

        <tr v-if="shippingData.address">
          <th class="w-px whitespace-nowrap">
            Адрес
          </th>
          <td>{{ shippingData.address }}</td>
        </tr>

        <tr v-if="shippingData.phone">
          <th class="w-px whitespace-nowrap">
            Номер телефона
          </th>
          <td>{{ shippingData.phone }}</td>
        </tr>

        <tr v-if="shippingData.workSchedule">
          <th class="w-px whitespace-nowrap">
            Режим работы
          </th>
          <td>{{ shippingData.workSchedule }}</td>
        </tr>

        <tr v-if="cartStore.shippingCostInKopecks !== null">
          <th class="w-px whitespace-nowrap">
            Доставка, ₽
          </th>
          <td>
            <template v-if="cartStore.isFreeShippingEnabled">
              0<br>
              <del>{{ helpers.formatPrice(cartStore.shippingCostInKopecks, true) }}</del>
            </template>
            <template v-else>
              {{ helpers.formatPrice(cartStore.shippingCostInKopecks, true) }}
            </template>
          </td>
        </tr>

        <tr v-if="shippingData.shippingPeriodInDays">
          <th class="w-px whitespace-nowrap">
            Срок доставки
          </th>
          <td>{{ shippingData.shippingPeriodInDays }}&nbsp;{{ helpers.getDeclension(shippingData.shippingPeriodInDays, constants.wordForms.workingDay) }}</td>
        </tr>
      </tbody>
    </table>
  </BlockWithBorder>
</template>
